import dynamic from 'next/dynamic';
import { InsuranceModalLoading } from 'shared/components/insurance-modal-loading';

export function preloadInsuranceCalculator() {
  return import('./pet-insurance-calculator-content');
}

const PetInsuranceCalculator = dynamic(() => import('./pet-insurance-calculator-content'), {
  ssr: false,
  loading: InsuranceModalLoading,
});

export default PetInsuranceCalculator;
